import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { Tag } from '../tag'
import { TagService } from '../tag.service'
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { Observable }  from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../admin.service'

@Component({
  selector: 'app-tag-button',
  templateUrl: './tag-button.component.html',
  styleUrls: ['./tag-button.component.css']
})
export class TagButtonComponent implements OnInit {
  @Input() tag: Tag
  @Input() dbRecord: DbRecord
  @Input() isEdit = false
  @Input() editable = false
  @Input() exportable = false
  title: string
  private submitTitleClicked = false
  isDeleteMode = false

  constructor(
    private router: Router,
    public rts: RuntimeService,
    private tags: TagService,
    private ads: AdminService
  ) { }

  ngOnInit() {
    if (!this.tag && this.rts.currentProject) {
      this.tag = this.tags.newTag()
    }
  }

  ngOnDestroy() {
    if (this.tag && this.tag.isNew)
      this.rts.currentProject.tagsMap.delete(this.tag.id)
  }

  init() {
    this.title = this.tag.title
  }

  get isExported() {
    return this.tags.isExportedTag(this.tag)
  }

  switchExport() {
    this.tags.switchExport(this.tag)
  }

  switchEdit() {
    if (this.isEdit)
      this.ngOnDestroy()
    this.isEdit = !this.isEdit
    if (this.isEdit)
      this.init()
    else
      this.ads.newTagOn = false
  }

  switchSelect() {
    if (!this.dbRecord)
      return
    this.tag.switch(this.dbRecord)
  }

  get isSelected() {
    if (!this.dbRecord)
      return false
    return this.tag.isSelected(this.dbRecord)
  }

  switchDelete() {
    this.isDeleteMode = !this.isDeleteMode
  }

  delete() {
    let obs: Observable<any> = this.tags.delete(this.tag)
    obs.subscribe((x) => null)
  }

  get hasTitleError() {
    return false
  }

  save() {
    this.submitTitleClicked = true
    if (this.hasTitleError)
      return
    this.tag.title = this.title
    let obs: Observable<any> = this.tags.save(this.tag)
    obs.subscribe((x) => {
        this.switchEdit()
        this.ads.newTagOn = false
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/tag-button/tag-button.component.ts